import VersionModalContainer from './VersionModal.container';

export default VersionModalContainer;
